// extracted by mini-css-extract-plugin
export var dropdownButton = "_1v-0";
export var fullWidthDropdownButton = "_1v-1";
export var icon = "_1v-3";
export var iconPlaceholder = "_1v-2";
export var menuItemRow = "_1v-8";
export var separator = "_1v-c";
export var shortcutContainer = "_1v-7";
export var shortcutIconLg = "_1v-6";
export var shortcutIconMd = "_1v-5";
export var shortcutIconSm = "_1v-4";
export var submenuChevron = "_1v-b";
export var submenuDropdown = "_1v-9";
export var submenuTriggerRow = "_1v-a";